// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__24yp-","alert":"SettungsInbox_alert__b51MG"};